<template>
  <li class="tree-node">
    <div 
      class="node-content" 
      :class="{
        'is-folder': node.children,
        'is-active': isActive
      }"
      @click="handleClick"
    >
      <span class="node-icon">
        {{ node.children ? (isOpen ? '📂' : '📁') : '📄' }}
      </span>
      <span class="node-label">{{ node.name }}</span>
    </div>
    <ul v-if="node.children && isOpen" class="node-children">
      <TreeNode 
        v-for="child in node.children" 
        :key="child.name" 
        :node="child"
        :active-path="activePath"
        @select="$emit('select', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeNode",
  props: {
    node: {
      type: Object,
      required: true,
    },
    activePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isActive() {
      return this.node.path === this.activePath;
    }
  },
  methods: {
    handleClick() {
      if (this.node.children) {
        this.isOpen = !this.isOpen;
      } else if (this.node.path) {
        this.$emit("select", this.node.path);
      }
    },
  },
};
</script>

<style scoped>
.tree-node {
  list-style: none;
  margin: 0;
  padding: 0;
}

.node-content {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin: 0.2rem 0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-primary);
}

.node-content:hover {
  background-color: var(--hover-bg);
}

.node-icon {
  margin-right: 0.5rem;
  font-size: 1.1em;
}

.node-label {
  font-size: 0.95rem;
}

.node-children {
  padding-left: 1.5rem;
}

/* 深色模式样式 */
:global(body.dark-mode) .node-content:hover {
  background-color: #2d2d2d;
}

:global(body.dark-mode) .node-content {
  color: #e1e1e1;
}

/* 选中状态 */
.node-content.selected {
  background-color: var(--selected-bg);
}

:global(body.dark-mode) .node-content.selected {
  background-color: #363636;
}

.node-content.is-active {
  background-color: var(--selected-bg);
  font-weight: 500;
}

.node-content.is-active:hover {
  background-color: var(--selected-bg);
}
</style>